
























































import interactable from '../../mixins/interactable/interactable';
import sizeable from '../../mixins/sizeable/sizeable';
import inputable from '../../mixins/inputable/inputable';
import mixins from '../../mixins';
// eslint-disable-next-line no-unused-vars
import ResponsePagingInfo from '../../plugins/servicelayer/responseTypes/responsePagingInfo';

export default mixins(interactable, sizeable, inputable).extend({
  mixins: [inputable, interactable, sizeable],
  props: {
    value: { default: () => ({}), type: Object },
    noPagingSize: { default: false, type: Boolean },
  },
  data: () => ({
  }),
  watch: {
    'value.totalPages': {
      handler() {
        this.setPage(this.value?.currentPage);
      },
    },
    'value.totalCount': {
      handler() {
        this.setPage(this.value?.currentPage);
      },
    },
    'value.pageSize': {
      handler() {
        this.setPage(this.value?.currentPage);
      },
    },
  },
  computed: {
    classList() {
      return {
        'p-pagination': true,
      };
    },
    textFieldSize() {
      if (this.spacious) {
        return 'ix-4';
      }
      if (this.dense) {
        return 'ix-2';
      }
      return 'ix-3';
    },
    display(): string {
      const paging = (this.value as ResponsePagingInfo);
      let currentPage = paging.currentPage ?? 1;
      if (Number.isNaN(currentPage)) {
        currentPage = 1;
      }
      return `${currentPage}/${this.getTotalPages(this.value)}`;
    },
  },
  methods: {
    getTotalPages(paging: ResponsePagingInfo) {
      if (paging.totalPages && (!paging.totalCount || !paging.pageSize)) {
        return paging.totalPages;
      }
      const pageSize = Math.max(1, paging.pageSize);
      const totalEntries = Math.max(1, paging.totalCount);
      let rounded = Math.ceil(totalEntries / pageSize);
      rounded = Number.isNaN(rounded) ? 1 : rounded;
      return rounded;
    },
    changePage(offset: number) {
      const newPage = this.value.currentPage + offset;
      this.setPage(newPage);
    },
    clampToPageSize(page: number | undefined | null): number {
      let newPage = page ?? 1;
      newPage = Math.min(this.getTotalPages(this.value), newPage);
      newPage = Math.max(1, newPage);
      return newPage;
    },
    setPage(page: number) {
      const newPage = this.clampToPageSize(page);
      if (newPage === this.value.currentPage) {
        return;
      }
      this.onInput({ ...this.value, currentPage: newPage });
    },
    setPageSize(pageSize: number) {
      this.onInput({ ...this.value, pageSize });
    },
  },
});
